import Box from "@mui/material/Box"
import { t } from "i18next"
import ExpandableSection from "../../common/ExpandableSection"
import PropertyRow from "../../common/PropertyTools/PropertyRow"
import MultiAlign from "./ExpandableSections/MultiAlign"
import MultiSize from "./ExpandableSections/MultiSize"

/** Size & position of a multiselection, laid out like the single object's section. */
const MultiselectItemsTools = () => {
    return (
        <ExpandableSection
            expanded={true}
            title={t("editor:size&positionSettings.title")}
            component={
                <Box display="flex" flexDirection="column" gap={1.5} width="100%" pb={0.5}>
                    <PropertyRow>
                        <MultiAlign />
                    </PropertyRow>
                    <MultiSize />
                </Box>
            }
        />
    )
}

export default MultiselectItemsTools
